export function isSpas() {
  if (isSimpleSpa()) {
    return false
  }

  return process.env.NUXT3_FEATURE_SPAS === 'true' || false
}

export function isNoSpas() {
  if (isSimpleSpa()) {
    return false
  }

  return process.env.NUXT3_FEATURE_NO_SPAS === 'true' || false
}

export function isPromos() {
  return process.env.NUXT3_FEATURE_PROMOS === 'true' || false
}

export function isTreatments() {
  return process.env.NUXT3_FEATURE_TREATMENTS === 'true' || false
}

export function isPackages() {
  return process.env.NUXT3_FEATURE_PACKAGES === 'true' || false
}

export function isSimpleSpa() {
  return process.env.NUXT3_FEATURE_SIMPLE_SPAS === 'true' || false
}

export function isRedirectionsSpa() {
  return process.env.NUXT3_FEATURE_REDIRECTIONS_SPA === 'true' || false
}

export function isRedirectionsService() {
  return process.env.NUXT3_FEATURE_REDIRECTIONS_SERVICE === 'true' || false
}

export function isRedirectionsPackage() {
  return process.env.NUXT3_FEATURE_REDIRECTIONS_PACKAGE === 'true' || false
}

export function isRedirectionsLegacy() {
  return process.env.NUXT3_FEATURE_REDIRECTIONS_LEGACY === 'true' || false
}

